import React, { useEffect } from "react";
import NavbarGuest from "./NavbarGuest";
import Footer from "./Footer";
import HiresText from "./commonTextPages/HiresText";
export default function HiresHome() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="fullScreenLayout">
        <NavbarGuest />
        <HiresText />
        <div className="flex-grow-1"></div>
        <Footer />
      </div>
    </>
  );
}
